import { render, staticRenderFns } from "./HelpQuickTips.vue?vue&type=template&id=5481a25e&"
import script from "./HelpQuickTips.vue?vue&type=script&lang=js&"
export * from "./HelpQuickTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports